import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Merntemplate extends Component {
  render() {
    const course = [
     {
          title: "Introduction to MERN Stack",
          content: [
            "Overview of MERN Stack",
            "Understanding each component (MongoDB, Express.js, React, Node.js)",
            "Benefits and use cases of MERN Stack",
            "Setting up the development environment"
          ]
        }, {
          title: "MongoDB: NoSQL Database",
          content: [
            "Introduction to MongoDB",
            "Installation and setup",
            "CRUD operations in MongoDB",
            "Data modeling in MongoDB",
            "Advanced queries and indexing"
          ]
        }, {
          title: "Express.js: Backend Framework",
          content: [
            "Introduction to Express.js",
            "Setting up a basic server",
            "Routing and middleware",
            "Working with requests and responses",
            "Error handling and middleware"
          ]
        }, {
          title: "React: Frontend Library",
          content: [
            "Introduction to React",
            "Components, props, and state",
            "Managing component lifecycle",
            "Routing with React Router",
            "Handling forms and user input"
          ]
        }, {
          title: "Node.js: Server-side JavaScript",
          content: [
            "Introduction to Node.js",
            "Setting up a Node.js server",
            "Working with modules and packages",
            "File system operations",
            "Event-driven programming with EventEmitter"
          ]
        }, {
          title: "Authentication and Authorization",
          content: [
            "User authentication strategies",
            "Implementing JWT (JSON Web Tokens) for authentication",
            "Role-based access control (RBAC)",
            "Securing routes and resources",
            "OAuth and OAuth2 for third-party authentication"
          ]
        }, {
          title: "Database Integration with Express",
          content: [
            "Connecting Express.js with MongoDB",
            "Using Mongoose for data modeling",
            "CRUD operations with Express and MongoDB",
            "Error handling and validation",
            "Managing database connections"
          ]
        }, {
          title: "State Management with Redux",
          content: [
            "Introduction to Redux",
            "Actions, reducers, and store",
            "Connecting Redux with React",
            "Managing global state in a MERN application",
            "Asynchronous actions and middleware"
          ]
        }, {
          title: "RESTful APIs and Microservices",
          content: [
            "Designing RESTful APIs",
            "Creating routes and endpoints",
            "Implementing CRUD operations",
            "Versioning APIs",
            "Microservices architecture and communication"
          ]
        }, {
          title: "Deployment and DevOps",
          content: [
            "Deploying MERN Stack applications",
            "Continuous integration and continuous deployment (CI/CD)",
            "Containerization with Docker",
            "Managing and scaling applications",
            "Monitoring and logging"
          ]
        }, {
          title: "Testing and Quality Assurance",
          content: [
            "Types of testing (unit testing, integration testing, end-to-end testing)",
            "Testing tools and frameworks (Jest, Enzyme, Supertest)",
            "Writing test cases for MERN Stack applications",
            "Automated testing and test coverage",
            "Debugging and troubleshooting"
          ]
        }
    ]

    const faqData = [
      {
        question: 'What is the MERN stack? ',
        answer:
          'MERN stands for MongoDB, Express.js, React, and Node.js. It is a popular full-stack JavaScript framework that allows developers to build modern, scalable, and high-performance web applications using a consistent language (JavaScript) across the entire application stack. ',
      },
      {
        question: 'What topics are covered in the MERN Full Stack course?',
        answer:
          'Our MERN Full Stack course covers a wide range of topics, including MongoDB (document database), Express.js (web application framework), React (front-end library), Node.js (server-side JavaScript runtime), RESTful APIs, authentication and authorization, deployment, and best practices for building scalable and maintainable full-stack applications.',
      },
      {
        question: ' Are there any prerequisites for learning MERN Stack?',
        answer:
          " It's recommended to have a good understanding of JavaScript, HTML, and CSS. Familiarity with web development concepts will be helpful in mastering MERN Stack technologies."
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Professionals with MERN Stack skills can pursue roles like Full-Stack Developer, mearn-stack-developer, Web Application Developer, JavaScript Developer, and more'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into MERN (MongoDB, Express.js, React, Node.js) Stack Development at the Best Training Centre. Our comprehensive MERN Stack Developer training program welcomes learners from diverse backgrounds, regardless of prior experience. Whether you're an aspiring developer eager to master the MERN stack or a seasoned programmer looking to expand your skill set, our courses cater to individuals at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential MERN stack concepts, including front-end and back-end technologies, database management, server-side scripting, and more. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in the dynamic field of MERN Stack Development. Join us and unlock your potential as a MERN Stack Developer with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Mohamed Azharutheen",
          date:" july 09 ,2023",
          review:` ${this.props.title} Training in  ${this.props.location} is  the first step towards a successful career in web development. It equips you with the knowledge and skills to   efficient and maintainable  ${this.props.title} frameworks. You can ensure you receive top-notch education in  ${this.props.title} . `
     },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Umar",
          date:" july 29 ,2023",
          review:" Mern Full Stack Development certification and unlock the doors to a promising career in web development. Elevate your skills, prove your expertise, and stand out in the competitive field of software development."
        },
  ]
 
     return(
      <>
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="MERN Stack is a combination of four powerful technologies: MongoDB (a NoSQL database), Express.js (a web application framework), React (a front-end library), and Node.js (a back-end runtime environment). It's used to build dynamic and interactive web applications."/> */}
          <NewMainsec rating='4.9' students={"849"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="MERN Stack is a combination of four powerful technologies: MongoDB (a NoSQL database), Express.js (a web application framework), React (a front-end library), and Node.js (a back-end runtime environment). It's used to build dynamic and interactive web applications."/>         

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`MERN Stack training in ${this.props.location} is a high-impact learning opportunity designed to propel your career in the dynamic field of MERN (MongoDB, Express.js, React, Node.js) development. At LearnCodePro, we offer top-notch MERN Stack training courses in ${this.props.location} to help you master the MERN Stack and gain a comprehensive understanding of its principles and practices. Our seasoned trainers employ a hands-on approach, incorporating real-world projects and practical exercises to deliver a well-rounded educational experience. Whether you're a novice looking to start a career in MERN development or an experienced developer eager to expand your skillset, LearnCodePro's MERN Stack training in ${this.props.location} is your ideal choice to unlock exciting career prospects. Contact us today to explore our courses and embark on your MERN Stack journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our MERN Stack course covers a comprehensive array of topics, including MongoDB database management, Express.js for robust backend development, React for creating engaging front-end interfaces, and Node.js for efficient server-side scripting. Our expert instructors will guide you through hands-on projects and real-world applications to ensure you grasp the core concepts and techniques employed in MERN Stack development. By the end of the course, you'll be well-prepared to implement MERN Stack practices in your own projects."}/>
  </section>
 <Batchtime title={this.props.title}  offer="29,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>       
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Automation Testing" coupath7="automation-testing" cou6='Mean Stack Developer' coupath6='mean-stack-developer' cou4=' Python Full Stack Developer' coupath4='python-full-stack-developer' cou='Web design' coupath='web-design' cou3='Ui-Ux Design' coupath3='ui-ux-design'
           cou9='Java Full Stack Developer ' coupath9='java-full-stack-developer' cou1='Software Testing' coupath1='software-testing'
          cou5='Web Development' coupath5='web-development' cou2='Selenium' coupath2='selenium'  cou8='Digital Marketing' coupath8='digital-marketing' />

      </>
    );
  }
}
